
<app-hero />

<section class="container home-container">

	<div class="flex flex-column sm:flex-row justify-content-between gap-4">
		<app-summary class="summary flex-grow-1" />
		<app-home-obituary class="obituary" />
	</div>

</section>
